export const webhookTypes = [
  {
    value: 'collect_session.complete',
    text: 'Collect session completed',
  },
  {
    value: 'document_state_changed',
    text: 'Document state changed',
  },
  {
    value: 'customer_approval_status_changed',
    text: 'Customer approval status changed',
  },
  {
    value: 'document_state_changed_minimal',
    text: 'Document state changed minimal',
  },
];
export const deprecatedWebhookTypes = [
  {
    value: 'document_state_changed_advanced',
    text: 'Document state changed (advanced) (deprecated)',
    disabled: true,
  },
  {
    value: 'document_processed',
    text: 'Document processed (deprecated)',
    disabled: true,
  },
];
